import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import ReactDOM from 'react-dom';

const psDropdown = (props) => {

  // The forwardRef is important!!
  // Dropdown needs access to the DOM node in order to position the Menu
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
         onClick(e);
      }}
    >
      {children}
    </a>
  ));

  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
      const value = '';

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <ul className="list-unstyled" style={{marginBottom: "0rem"}}>
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value),
            )}
          </ul>
        </div>
      );
    },
  );

  // Überprüfe, ob wir Portal verwenden sollen
  const menu = (
    <Dropdown.Menu as={CustomMenu}>
      {props.items.map(x => 
        <Dropdown.Item 
          disabled={x.disabled} 
          key={x.id} 
          eventKey="1" 
          onClick={x.action}
        >
          {x.text}
        </Dropdown.Item>
      )}
    </Dropdown.Menu>
  );

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        {(props.children === undefined) ?
          <button className="btn-options caret-off" type="button">
            <i className="material-icons">more_vert</i>
          </button>
          : props.children}
      </Dropdown.Toggle>
      
      {props.portalTarget 
        ? ReactDOM.createPortal(menu, props.portalTarget)
        : menu
      }
    </Dropdown>
  );
};

export default psDropdown;



// WEBPACK FOOTER //
// ./src/components/UI/PsDropdown.js